import { cronosClient } from "@/config/client"

export type CourseStatus = "reschedule" | "at_risk" | "on_track"
export type CourseTargetObjetive = "approve" | "outstanding" | "excel"

interface Course {
  id: string
  name: string
  subjectId: string
  remainingStudyTime: string
  targetObjective: CourseTargetObjetive
  status: CourseStatus
  startDate: string
  endDate: string
}

export interface GetCourseResponse {
  description: {
    courses: Course[]
    more: boolean
  }
}

export function get() {
  return cronosClient.get<GetCourseResponse>("/v1/courses")
}
